import { QuanLyHoSo } from "api";
import DataTable from "components/data-table";
import { header } from "constants/table";
import { MasterLayout } from "layout";
import { RowItemVanBanXuLy, RowItemCanCuCuocThanhTra } from "modules/quan-ly-ho-so/datatable";
import React from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { browserHistory, Link } from "react-router";

class ChiTietQuanLyHoSo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      listCanCuCuocThanhTra: [],
      listNhomHoSo: [],
    };
  }

  componentDidMount() {
    if (this.props.params && this.props.params.id) {
      this.getDetailQuanLyHoSo(this.props.params.id);
    }
  }

  getDetailQuanLyHoSo(id) {
    QuanLyHoSo.actions.getChiTietQuanLyHoSo.request({ id: id }).then((res) => {
      if (!isEmpty(res.data)) {
        this.setState({
          ...this.state,
          listCanCuCuocThanhTra: res.data.cuocThanhTra.danhMucVanBans,
          listNhomHoSo: res.data.listNhomHoSo
        });
      }
    });
  }

  handleClose() {
    browserHistory.goBack();
  }

  renderListNhomHoSo() {
    const result = !isEmpty(this.state.listNhomHoSo) ? this.state.listNhomHoSo.map((item, index) => (
      <section className="wrap-block">
        <div className="row pl10 pr10 heading-addnew-dttt">
          <h2 className="title-13 col-100 pl20 pr20 mt10">
            {`${index + 2}. ${item.ten}`}
          </h2>
        </div>
        <div className="row pl10 pr10 ">
          <DataTable
            header={header.quanLyHoSo.dsVanBanXuLy}
            dataList={item.listTaiLieuVanThu}
            hideButtonExport={true}
            hidePagination={true}
            pageData={this.state.pageData}
            parent={this}
            search={this.state.search}
            tableLoading={this.state.tableLoading}
          >
            <RowItemVanBanXuLy />
          </DataTable>
        </div>
      </section>
    )) : ''
    return result;
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="back-foward">
            <Link onClick={this.handleClose.bind(this)} title="">
              Về trang trước
            </Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">Thông tin chi tiết hồ sơ</h2>
          </div>
          <div className="bottom-content">
            <section className="wrap-block">
              <div className="row pl10 pr10 heading-addnew-dttt">
                <h2 className="title-13 col-100 pl20 pr20 mt10">
                  1. Căn cứ cuộc thanh tra
                </h2>
              </div>
              <div className="row pl10 pr10 ">
                <DataTable
                  header={header.dsCanCuCuocThanhTra}
                  dataList={this.state.listCanCuCuocThanhTra}
                  hideButtonExport={true}
                  hidePagination={true}
                  pageData={this.state.pageData}
                  parent={this}
                  search={this.state.search}
                  tableLoading={this.state.tableLoading}
                >
                  <RowItemCanCuCuocThanhTra />
                </DataTable>
              </div>
            </section>
            {
              this.renderListNhomHoSo()
            }
          </div>
          <div className="action-form-wrap pt35 pb5">
            <div className="box-bottom">
              <Link
                className="btn-action btn-close"
                onClick={this.handleClose.bind(this)}
              >
                <span>Đóng</span>
              </Link>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default connect()(ChiTietQuanLyHoSo);



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-ho-so/ChiTietQuanLyHoSo.jsx